import React, { useContext } from "react";
import classes from "./Footer.module.css";
import NewsLetter from "../../Home page/NewsLetter section/NewsLetter";
import CopyrightIcon from "@mui/icons-material/Copyright";
import FaceBook from "../../../assets/FaceBook.png";
import LinkedIn from "../../../assets/LinkedIn.png";
import Instagram from "../../../assets/Instagram.png";
import YouTube from "../../../assets/YouTube.png";
import Twitter from "../../../assets/Twitter.png";
import { toast } from "react-toastify";
import logo from "../../../assets/logo1.png";
import background from "../../../assets/FOOTER.png";
import NorthIcon from '@mui/icons-material/North';
import data from '../../Data.json';
import { useSelector } from "react-redux";
import AuthContext from "../authContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Link as LinkSS } from "react-scroll";
import * as Scroll from "react-scroll";

const Footer = () => {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const authCtx = useContext(AuthContext)
    const navigate = useNavigate();
    const path = useLocation().pathname;
    const location = path.split("/")[1];
      const scroller = Scroll.scroller;
    
      const NavigateAndScroll = async (props) => {
        await navigate("/");
        scroller.scrollTo(props, {
          duration: 500,
          delay: 100,
          smooth: true,
          offset: 50,
        });
      };

  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Use smooth scrolling animation
    });
  };
  return (
    <>
      <div style={{ width: "100%", position: "relative",backgroundColor:'var(--primary-color)',maxWidth: '1900px', margin: '0 auto' }}>
        <div className={classes.background}>
          <img src={background} alt="background"/>
        </div>
        <div className={classes.footer}>
          <NewsLetter />
          <div className={classes.content}>
            <div className={classes.top_con} onClick={()=>console.log(authCtx.companySettings)}>
              <img src={authCtx.companySettings.light_icon} alt="Logo"/>
            </div>
            <div className={classes.middle_con}>
              <div className={classes.column}>
                <h2>{data.Footer.WhoWeAre.title[language]} ?</h2>
                <p dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx.companySettings.about_en : authCtx.companySettings.about_fr }} />
              </div>
              <div  className={classes.column}>
                <h2>{data.Footer.NeedHelp.title[language]} ?</h2>
                <p dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx.companySettings.help_en : authCtx.companySettings.help_fr }} />
              </div>
              <div  className={classes.column}>
                <h2>{data.Footer.Library.title[language]}</h2>
              <p dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx.companySettings.libraries_en : authCtx.companySettings.libraries_fr }} />
              </div>
              <div  className={classes.column}>
              <h2>{data.Footer.Service.title[language]}</h2>
              <ul style={{ listStyle: "disc", paddingLeft: "1.2em", margin: 0 }}>
                <li>
                  <Link to="/products">
                    <p style={{margin: 0}}>{language === "eng" ? "Products" : "Produits"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/collaborators">
                    <p style={{margin: 0}}>{language === "eng" ? "Collaborators" : "Collaborateurs"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/collections">
                    <p style={{margin: 0}}>{language === "eng" ? "Collections" : "Collections"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/contactus">
                    <p style={{margin: 0}}>{language === "eng" ? "Contact" : "Contact"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/legal-information">
                    <p style={{margin: 0}}>{language === "eng" ? "Legal information" : "Mentions légales"}</p>
                  </Link>
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="new_products" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "New products" : "Nouveautés"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("new_products")}>
                      {language === "eng" ? "New products" : "Nouveautés"}
                    </p>
                  )}
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="Best_sales" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "Best sales" : "Meilleures ventes"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("Best_sales")}>
                      {language === "eng" ? "Best sales" : "Meilleures ventes"}
                    </p>
                  )}
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="favorites" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "Favorites" : "Coups de cœur"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("favorites")}>
                      {language === "eng" ? "Favorites" : "Coups de cœur"}
                    </p>
                  )}
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="newsletter" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "Newsletter" : "Newsletter"}
                      </p>
                    </LinkSS> 
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("newsletter")}>
                      {language === "eng" ? "Newsletter" : "Newsletter"}
                    </p>
                  )}
                </li>
              </ul>
              </div>
            </div>
            
            <div className={classes.middle_con_mobile}>
              <div className={classes.column}>
              <h2>{data.Footer.WhoWeAre.title[language]} ?</h2>
                <p dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx.companySettings.about_en : authCtx.companySettings.about_fr }} />
              </div>
             <div style={{display: 'grid', gridTemplateColumns:'50% 50%', rowGap:'1em'}}>
              <div style={{ display:'flex', flexDirection:'column',rowGap:'1em'}}>
             <div  className={classes.column}>
             <h2>{data.Footer.NeedHelp.title[language]} ?</h2>
                <p dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx.companySettings.help_en : authCtx.companySettings.help_fr }} />
              </div>
              
              <div  className={classes.column}>
              <h2>{data.Footer.Library.title[language]}</h2>
              <p dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx.companySettings.libraries_en : authCtx.companySettings.libraries_fr }} />
              </div>
              </div>
              <div  className={classes.column}>
              <h2>{data.Footer.Service.title[language]}</h2>

              <ul style={{ listStyle: "disc", paddingLeft: "1.2em", margin: 0 }}>
                <li>
                  <Link to="/products">
                    <p style={{margin: 0}}>{language === "eng" ? "Products" : "Produits"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/collaborators">
                    <p style={{margin: 0}}>{language === "eng" ? "Collaborators" : "Collaborateurs"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/collections">
                    <p style={{margin: 0}}>{language === "eng" ? "Collections" : "Collections"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/contactus">
                    <p style={{margin: 0}}>{language === "eng" ? "Contact" : "Contact"}</p>
                  </Link>
                </li>
                <li>
                  <Link to="/legal-information">
                    <p style={{margin: 0}}>{language === "eng" ? "Legal information" : "Mentions légales"}</p>
                  </Link>
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="new_products" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "New products" : "Nouveautés"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("new_products")}>
                      {language === "eng" ? "New products" : "Nouveautés"}
                    </p>
                  )}
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="Best_sales" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "Best sales" : "Meilleures ventes"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("Best_sales")}>
                      {language === "eng" ? "Best sales" : "Meilleures ventes"}
                    </p>
                  )}
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="favorites" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "Favorites" : "Coups de cœur"}
                      </p>
                    </LinkSS>
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("favorites")}>
                      {language === "eng" ? "Favorites" : "Coups de cœur"}
                    </p>
                  )}
                </li>
                <li>
                  {location === "/" ? (
                    <LinkSS to="newsletter" smooth={true} style={{ cursor: 'pointer' }} duration={500}>
                      <p style={{margin: 0}}>
                        {language === "eng" ? "Newsletter" : "Newsletter"}
                      </p>
                    </LinkSS> 
                  ) : (
                    <p style={{margin: 0, cursor: 'pointer'}} onClick={() => NavigateAndScroll("newsletter")}>
                      {language === "eng" ? "Newsletter" : "Newsletter"}
                    </p>
                  )}
                </li>
              </ul>
              </div>
             </div>
            </div>
            <div className={classes.bottom_con}>
              <p>{language === 'eng' ? "Follow Us" : "Suivez-nous"} !</p>
                <div className={classes.iconsContainer}>
                  {authCtx?.companySettings?.facebook && (
                    <a
                      href={authCtx.companySettings.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <img className={classes.socialsIcon} src={FaceBook} alt="Facebook" />
                    </a>
                  )}
                  {authCtx?.companySettings?.youtube && (
                    <a
                      href={authCtx.companySettings.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="YouTube"
                    >
                      <img className={classes.socialsIcon} src={YouTube} alt="YouTube" />
                    </a>
                  )}
                  {authCtx?.companySettings?.twitter && (
                    <a
                      href={authCtx.companySettings.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Twitter"
                    >
                      <img className={classes.socialsIcon} src={Twitter} alt="Twitter" />
                    </a>
                  )}
                  {authCtx?.companySettings?.linkedin && (
                    <a
                      href={authCtx.companySettings.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <img className={classes.socialsIcon} src={LinkedIn} alt="LinkedIn" />
                    </a>
                  )}
                  {authCtx?.companySettings?.insta && (
                    <a
                      href={authCtx.companySettings.insta}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <img className={classes.socialsIcon} src={Instagram} alt="Instagram" />
                    </a>
                  )}
                </div>
            </div>
          </div>
        </div>
        <div className={classes.copyRight}>
          <p style={{width:'100%', margin:'0 auto', fontSize: 'calc(0.7rem + 0.3vw)' }}>
            &copy; {language === 'eng' ? authCtx.companySettings.copyrights_en : authCtx.companySettings.copyrights_fr } 
          </p>
        </div>
      </div>
      <div onClick={scrollToTop} className={classes.scroll}>
        <NorthIcon  style={{margin:'10% 0 0 0', width:'100%', height:'80%'}}/>
      </div>
    </>
  );
};

export default Footer;
